export type ActionTypes = {
  APP_RESET: string;
  APP_LOADED_START: string;
  APP_LOADED_SUCCESS: string;

  APP_LOADING_BAR_START: string;
  APP_LOADING_BAR_END: string;


  LOGIN_START: string;
  LOGIN_SUCCESS: string;
  LOGIN_FAILED: string;

  LOGOUT_START: string;
  LOGOUT_SUCCESS: string;
  LOGOUT_FAILED: string;

  VERIFY_TOKEN_START: string;
  VERIFY_TOKEN_SUCCESS: string;
  VERIFY_TOKEN_FAILED: string;

  EXPIRE_SESSION_SUCCESS: string;
  EXPIRE_SESSION_FAILED: string;

  USER_SET_UNACKNOWLEDGED_NOTIFICATION_COUNT: string,
  USER_MULTI_FACTOR_VERIFIED: string;

  APP_ADD_LOCATION_HISTORY: string;
  APP_SET_ROUTES: string;
}

const actionTypes: ActionTypes = {

  APP_RESET: 'APP_RESET',
  APP_LOADED_START: 'APP_LOADED_START',
  APP_LOADED_SUCCESS: 'APP_LOADED_SUCCESS',

  APP_LOADING_BAR_START: 'APP_LOADING_BAR_START',
  APP_LOADING_BAR_END: 'APP_LOADING_BAR_END',

  LOGIN_START: 'LOGIN_START',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',

  LOGOUT_START: 'LOGOUT_START',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILED: 'LOGOUT_FAILED',

  VERIFY_TOKEN_START: 'VERIFY_TOKEN_START',
  VERIFY_TOKEN_SUCCESS: 'VERIFY_TOKEN_SUCCESS',
  VERIFY_TOKEN_FAILED: 'VERIFY_TOKEN_FAILED',

  EXPIRE_SESSION_SUCCESS: 'EXPIRE_SESSION_SUCCESS',
  EXPIRE_SESSION_FAILED: 'EXPIRE_SESSION_FAILED',

  USER_SET_UNACKNOWLEDGED_NOTIFICATION_COUNT: 'USER_SET_UNACKNOWLEDGED_NOTIFICATION_COUNT',
  USER_MULTI_FACTOR_VERIFIED: 'USER_MULTI_FACTOR_VERIFIED',

  APP_ADD_LOCATION_HISTORY: 'APP_ADD_LOCATION_HISTORY',
  APP_SET_ROUTES: 'APP_SET_ROUTES',
}

export default actionTypes